module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en.json
// module id = 407
// module chunks = 253844482878330